import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import SimpleBar from 'simplebar';

import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $referencesLink: this.el._$('.product-references__link'),
      $citations: this.el._$$('.product-references__reference')
    };
    this.modalId = null;

    this.openTrigger = 'data-generic-modal-open';
    this.closeTrigger = 'data-generic-modal-close';
    this.openClass = 'generic-modal--open';

    this.init();
    this.hideIfEmpty();
  }

  addListeners() {
    const { $referencesLink } = this.dom;

    $referencesLink?._on('click', this.openModal.bind(this));

    $(document).on('click', '.atcc-bioz-w-link', e => {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('#product-references').offset().top - 90
      }, 600);
    })

    $(window).on('load', () => {
      if (window.location.href.toString().includes('nt')) {
        $('html, body').animate({ scrollTop: $('#product-references').offset().top - 90 }, 600);
      }
    })

    $(document).ready(() => {
      $('.product-references__container *').each(function(){
        if ($(this).css('display') === 'none') {
          $(this).remove();
        }
      })
      $('.product-references__container script').remove();
      if ($('.product-references__container').text().split('\n').join('').split('\t').join('').split(' ').join('') === 'References'){
        $('.product-references__container').remove();
        $('a[data-anchor-id="product-references"]').hide();
      }
    })

  }

  openModal(e) {
    e?.preventDefault();

    if (this.modalId) {
      MicroModal.show(this.modalId, {
        openTrigger: this.openTrigger,
        closeTrigger: this.closeTrigger,
        openClass: this.openClass,
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: modal => {
          $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
          document.body.classList.add('show-modal');
        },
        onClose(modal) {
          document.body.classList.remove('show-modal');
        }
      });
    }
  }

  setSimpleBars() {
    try {
      Array.prototype.forEach.call(
        document.querySelectorAll('.product-references__modal-container'),
        el => new SimpleBar(el, { autoHide: false })
      );
    } catch (error) {
      return;
    }
  }

  init() {
    const { $el } = this.dom;
    const $genericModal = $el._$('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }

    this.setSimpleBars();
  }

  hideIfEmpty() {
    setTimeout(() => {
      if (!(this.dom.$citations.length > 0 || this.dom.$el.getElementsByTagName('table').length)) {
        this.dom.$el.remove();
        const anchorId = this.dom.$el.getAttribute('id') || null;
        dispatchGenericEvent(constEvent.PDP_REMOVED_REFERENCES, anchorId);
      }
    }, 1000);
  }
}

export default Module;
